import React, { useMemo } from 'react'
import ReactSelect from 'react-select'
import { classNames } from 'core/helpers/misc'

export const Select = ({
    getDisplay,
    getId,
    meta = {},
    selected,
    items,
    onChange,
    placeholder = 'Selecione...',
    noItemMessage = 'Nenhum resultado foi encontrado.',
    loadingMessage = () => 'Carregando...',
    disabled,
    isMulti,
    ...props
}) => {
    const selectedById = useMemo(
        () => items.find(i => getId(i) === selected),
        // eslint-disable-next-line
        [items, selected]
    )

    const hasError = meta.touched && !!meta.error

    return (
        <div
            className={classNames({
                'is-invalid': hasError,
            })}
        >
            <ReactSelect
                {...props}
                classNamePrefix="react-select"
                closeMenuOnSelect={isMulti}
                getOptionLabel={getDisplay}
                getOptionValue={getId}
                isDisabled={disabled}
                isMulti={isMulti}
                loadingMessage={loadingMessage}
                noOptionsMessage={() => noItemMessage}
                onChange={v => {
                    if (onChange) {
                        onChange(isMulti && !v ? [] : v)
                    }
                }}
                options={items}
                placeholder={placeholder}
                value={selectedById || selected}
            />

            {hasError && <div className="form-text text-danger">{meta.error}</div>}
        </div>
    )
}
